module.exports = __webpack_public_path__ + "img/saum_alugrau_ral7037.838d7774.jpg";